export default {
    newsCenter: {
        path: '/website/newsCenter',
        name: 'news-center',
        component: () => import('./index.vue')
    }
};
